import { TransactionLogService } from './transaction-log.service';
import { UserService } from './user.service';
import { SocketService } from './socket.service';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./socket.service";
import * as i3 from "./transaction-log.service";
import * as i4 from "./user.service";
var ClearService = /** @class */ (function () {
    function ClearService(router, socketService, transactionLogService, userService) {
        this.router = router;
        this.socketService = socketService;
        this.transactionLogService = transactionLogService;
        this.userService = userService;
    }
    ClearService.prototype.logout = function () {
        // Save current state info to localSession
        sessionStorage.setItem('prevState', JSON.stringify({
            // name: this.stateService.current.name,
            path: this.router.url
        }));
        // Clear selectedCustomer
        // this.userService.selectedCustomerId.next(null);
        this.userService.selectedCustomer.next(null);
        // Remove token
        this.userService.removeToken();
        this.userService.removeA3iApiKey();
        // Disconnect socket
        this.socketService.disconnectSocket();
        this.transactionLogService.socketProcesses.next([]);
        // this.stateService.go('login');
        this.router.navigate(['/auth/login'], {
            queryParamsHandling: 'merge' // To keep socket sidekick params
        });
    };
    ClearService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ClearService_Factory() { return new ClearService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.SocketService), i0.ɵɵinject(i3.TransactionLogService), i0.ɵɵinject(i4.UserService)); }, token: ClearService, providedIn: "root" });
    return ClearService;
}());
export { ClearService };
